import {
  Select,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  SelectProps,
  Input
} from "@chakra-ui/react";
import React from "react";


function Component(props: SelectProps) {
  const { children } = props

  return (
    <Menu>
      <MenuButton>
        <Select { ...props }></Select>
      </MenuButton>

      <MenuList>
        <MenuOptionGroup>
          <Input placeholder=""></Input>
        </MenuOptionGroup>
        <MenuDivider />
        <MenuOptionGroup title='Options' type='checkbox'>
          <MenuItemOption value='email'>Email</MenuItemOption>
          <MenuItemOption value='phone'>Phone</MenuItemOption>
          <MenuItemOption value='country'>Country</MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  )
}

export { Component as Select }